import { useContext } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import PrivateRoute from './PrivateRoute';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import AuthContext from './contexts/auth';
import ConfirmPage from 'components/ConfirmPage';
import PaymentSuccessPage from 'components/PaymentSuccessPage';
import PaymentFailPage from 'components/PaymentFailPage';

// import theme from './theme'

import './assets/styles/global-style.scss';

const theme = createTheme({
  direction: 'rtl',
  palette: {
    primary: {
      main: '#84BD00'
    }
  }
});

const cacheRtl = createCache({
  key: 'muirtl',
  // prefixer is the only stylis plugin by default, so when
  // overriding the plugins you need to include it explicitly
  // if you want to retain the auto-prefixing behavior.
  stylisPlugins: [prefixer, rtlPlugin]
});

const MovementApp = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const value = { isAuthenticated };

  return (
    <AuthContext.Provider value={value}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <Router>
            <Routes>
              <Route exact path="/" element={<PrivateRoute />} />
              <Route exact path="/:entity" element={<PrivateRoute />} />
              <Route exact path="/:entity/:id" element={<PrivateRoute />} />
              <Route
                exact
                path="/:entity/:id/:idd"
                element={<PrivateRoute />}
              />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/verification" element={<LoginPage />} />
              <Route path="/forgot-password" element={<LoginPage />} />
              <Route path="/new-password" element={<LoginPage />} />
              <Route path="/payment" element={<div>pay ...</div>} />
              <Route path="/confirm" element={<ConfirmPage />} />
              <Route path="/payment-success" element={<PaymentSuccessPage />} />
              <Route path="/payment-fail" element={<PaymentFailPage />} />
            </Routes>
          </Router>
        </ThemeProvider>
      </CacheProvider>
    </AuthContext.Provider>
  );
};

ReactDOM.render(<MovementApp />, document.getElementById('root'));
